import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import SubleagueDetail from "@/pages/SubleagueDetail";

function App() {
    return (
        <div className="App" data-testid="app-root">
            <BrowserRouter>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/subleague/:id" element={<SubleagueDetail />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Route>
                </Routes>
            </BrowserRouter>
            <Toaster
                theme="dark"
                position="top-right"
                toastOptions={{
                    style: {
                        background: "#141414",
                        color: "#fff",
                        border: "1px solid #27272a",
                        borderRadius: "2px",
                    },
                }}
            />
        </div>
    );
}

export default App;
